import { AdminRoutes } from "@/data/enums/router";
import i18n from "@/i18n";
import type {
  ICProdProvider,
  ICProdProvProvider
} from "@/models/providers/contractProduct";
import type { IMenuRoute } from "@/models/routes";
import store from "@/store";
import _ from "@/boot/lodash";
import { BrandConfigKeys } from "@upmind-automation/types";

/**
 * Top-level tabigation for client contract products.
 * Mirrors the brand-level tab layout: Subscriptions | One-time purchases | All
 */
export function clientCProdTabigation(): IMenuRoute[] {
  return [
    {
      label: i18n.t("_.subscriptions"),
      to: { name: "admin__clientSubscriptions" }
    },
    {
      label: i18n.t("_.one_time_purchases"),
      to: { name: "admin__clientOTPs" }
    },
    {
      label: i18n.t("_.all_products_and_services"),
      to: { name: "admin__clientAllProducts" }
    }
  ];
}

export function cProdTabigation({
  cProdData,
  cProdProvData
}: {
  cProdData: ICProdProvider;
  cProdProvData: ICProdProvProvider;
}) {
  return [
    {
      label: i18n.t("_.setup"),
      to: {
        name: AdminRoutes.CONTRACT_PRODUCT_SETUP
      },
      if: () => cProdData.isAwaitingSetup
    },
    {
      label: i18n.t("_.overview"),
      to: {
        name: AdminRoutes.CONTRACT_PRODUCT_OVERVIEW
      }
    },
    {
      label: i18n.t("_.notes_and_secrets"),
      to: {
        name: `adminClientCProdVault`
      },
      if: () => {
        const config = store.getters["brand/config"];
        return _.get(config, BrandConfigKeys.CLIENT_NOTES_AND_SECRETS_ENABLED);
      }
    },
    {
      label: i18n.t("_.tickets"),
      to: {
        name: AdminRoutes.CONTRACT_PRODUCT_TICKETS
      }
    },
    {
      label: i18n.t("_.invoices"),
      to: {
        name: AdminRoutes.CONTRACT_PRODUCT_INVOICES
      }
    },
    {
      label: i18n.t("_.credit_notes"),
      to: {
        name: `adminClientCProdCreditNotes`
      }
    },
    {
      label: i18n.t("_.manage"),
      to: {
        name: AdminRoutes.CONTRACT_PRODUCT_PROVISIONING
      },
      if: () => {
        return cProdProvData.canManageProvisioning;
      }
    },
    {
      label: i18n.t("_.settings"),
      to: {
        name: `adminClientCProdSettings`
      },
      if: () => {
        return cProdData.canModifySettings;
      }
    },
    {
      label: i18n.t("_.scheduled_changes"),
      to: {
        name: AdminRoutes.CONTRACT_PRODUCT_SCHEDULED_CHANGES
      },
      if: () => {
        return cProdData.hasScheduledChanges;
      }
    },
    {
      label: i18n.t("_.delegates"),
      to: {
        name: `adminClientCProdDelegates`
      }
    },
    {
      label: i18n.t("_.activity_log"),
      to: {
        name: `adminClientCProdActivities`
      }
    }
  ];
}
